import { forwardRef } from 'react';
import { SegmentedControlItemProps } from '../types';
import { SegmentedControlButton } from './style';

export const SegmentedControlItem = forwardRef<HTMLButtonElement, SegmentedControlItemProps & { tabIndex?: number }>(
    ({ checked, disabled, onChange, value, label, itemWidth = 'evenly', tabIndex, ...other }, ref) => {
        const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            if (onChange) {
                onChange(event, value);
            }
        };

        return (
            <SegmentedControlButton
                ref={ref}
                checked={checked}
                disabled={disabled}
                onClick={handleClick}
                role="radio"
                aria-checked={checked}
                itemWidth={itemWidth}
                tabIndex={tabIndex}
                {...other}
            >
                {label}
            </SegmentedControlButton>
        );
    }
);
